var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.355,
    height: 15.943,
    viewBox: "0 0 14.355 15.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bag",
    d: "M-20.022,7.375V5.981A3.986,3.986,0,0,0-24.008,2a3.986,3.986,0,0,0-3.986,3.986V7.375h-3.192v8.072a2.491,2.491,0,0,0,2.491,2.491h9.373a2.491,2.491,0,0,0,2.491-2.491V7.375ZM-27,5.981a2.99,2.99,0,0,1,2.989-2.99,2.99,2.99,0,0,1,2.989,2.99V7.375H-27Zm9.17,9.466a1.494,1.494,0,0,1-1.5,1.494h-9.373a1.494,1.494,0,0,1-1.5-1.494V8.371h12.363Z",
    transform: "translate(31.186 -1.995)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.bb8b4412cc9ac055e9f2ec4946759628.svg";
export { ForwardRef as ReactComponent };